import { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu, menuClasses } from "react-pro-sidebar";
import { NavLink, useNavigate, useHref } from "react-router-dom";
import { DDD, E2Data, tx } from "../../lib/ddd/ddd";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
const data = new E2Data("EU_Invoices");
data.filter="DeviceId__AssignedTo = 'CKI'";
data.take = 0;
data.includeCount = true;

const MenuItemInterval = ({index, item, parentRef}) =>{
    const [num, setNum] = useState(0);
    const [firstLoad, setFirstLoad] = useState(false);

    useEffect(() => {
        if(!firstLoad){
            reloadNumbers();
            setFirstLoad(true);
        }
            
        const intervalId = setInterval(() =>{
            if(parentRef?.current?.classList?.contains("ps-open"))
                reloadNumbers()
        },15000);
        return () => clearInterval(intervalId);
    }, []);

    const reloadNumbers = () =>{
        data.GetData().then(res => {
            if(res.result?.count)
            setNum(res.result?.count||0)
        });
    }
    return(
    <MenuItem
        key={`sidemenu-item-${index}-${item.itemName}`}
        component={<NavLink to={item.url} />}
        style={{color : "white"}} 
        icon={item.icon}
        suffix = {<span style={{fontSize:"0.6rem", backgroundColor:"rgb(24, 185, 24)", paddingLeft:"5px", paddingRight:"5px"}}>{num}</span>}
        >
        {tx(item.itemName)}
        </MenuItem>
    )
}

const Sfx = ({num}) =>{
    return (<span style={{fontSize:"0.7rem", borderRadius:"50%", backgroundColor:"#18b918"}}>{num}</span>)
}

export default MenuItemInterval;